import { render } from "./ProviderSelector.vue?vue&type=template&id=38574fb0&scoped=true"
import script from "./ProviderSelector.vue?vue&type=script&lang=js"
export * from "./ProviderSelector.vue?vue&type=script&lang=js"

import "./ProviderSelector.vue?vue&type=style&index=0&id=38574fb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38574fb0"]])

export default __exports__